import { render, staticRenderFns } from "./GroupCalendarPage.vue?vue&type=template&id=4f056c9b&scoped=true&"
import script from "./GroupCalendarPage.vue?vue&type=script&lang=js&"
export * from "./GroupCalendarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f056c9b",
  null
  
)

export default component.exports